export interface ChannelStatusId {
    /**
     * ChannelId
     */
    c: number;

    /**
     * Game type
     */
    g: ChannelStatusGame;

    /**
     * Partition number
     */
    p: number;
}

export enum ChannelStatusGame {
    Live = 'Live',
    Prematch = 'Prematch',
    VirtualOnline = 'VirtualOnline',
    VirtualOffline = 'VirtualOffline'
}

export interface ChannelStatusResponse extends ChannelStatusId {
    /**
     * Channel enabled flag
     */
    e: boolean;

    /**
     * Valid until timestamp
     */
    v: number;
    /**
     * Chanel status delayed
     */
    d: boolean;
}

export const emptyDivClassesBefore = ['empty', 'empty'];
export const emptyDivClassesAfter = ['empty-result', 'empty-score', 'empty-dummy', 'empty-errorReason', 'empty-last'];
export const closingWrapperName = 'cashin-closing-wrapper ';
